package com.evoapps.evoshift.ui.hiring

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.OpenInNew
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Share
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalClipboard
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem
import com.evoapps.evoshift.domain.model.CvFileType
import com.evoapps.evoshift.domain.model.CvRequirement
import com.evoapps.evoshift.domain.model.CvSettings
import com.evoapps.evoshift.domain.model.RejectionMailTemplate
import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.widgets.EvoSwitchRow
import com.evoapps.evoshift.domain.model.JobContractType
import com.evoapps.evoshift.domain.model.JobPost
import com.evoapps.evoshift.domain.model.JobPostStatus
import com.evoapps.evoshift.domain.model.PayUnit
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.jobPostProblemText
import com.evoapps.evoshift.util.plainTextClipEntry
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.JobPostEditorViewModel
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoDateField
import com.evoapps.evoshift.widgets.MissingYear
import com.evoapps.evoshift.widgets.EvoDropdown
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import com.evoapps.evoshift.widgets.EvoSecondaryButton
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.LoadingOverlay
import com.evoapps.evoshift.widgets.StandoutCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.job_close
import evoshift.composeapp.generated.resources.job_contract_b2b
import evoshift.composeapp.generated.resources.job_contract_employment
import evoshift.composeapp.generated.resources.job_contract_mandate
import evoshift.composeapp.generated.resources.job_contract_other
import evoshift.composeapp.generated.resources.job_delete
import evoshift.composeapp.generated.resources.job_delete_confirm_text
import evoshift.composeapp.generated.resources.job_delete_confirm_title
import evoshift.composeapp.generated.resources.job_editor_new_title
import evoshift.composeapp.generated.resources.job_editor_title
import evoshift.composeapp.generated.resources.job_field_city
import evoshift.composeapp.generated.resources.job_field_closes
import evoshift.composeapp.generated.resources.job_field_contact
import evoshift.composeapp.generated.resources.job_field_contact_hint
import evoshift.composeapp.generated.resources.job_field_contract
import evoshift.composeapp.generated.resources.job_field_description
import evoshift.composeapp.generated.resources.job_field_employer
import evoshift.composeapp.generated.resources.job_field_employer_hint
import evoshift.composeapp.generated.resources.job_field_hours
import evoshift.composeapp.generated.resources.job_field_hours_hint
import evoshift.composeapp.generated.resources.job_field_language
import evoshift.composeapp.generated.resources.job_field_pay_max
import evoshift.composeapp.generated.resources.job_field_pay_min
import evoshift.composeapp.generated.resources.job_field_role
import evoshift.composeapp.generated.resources.job_field_title
import evoshift.composeapp.generated.resources.job_field_title_hint
import evoshift.composeapp.generated.resources.job_lang_en
import evoshift.composeapp.generated.resources.job_lang_pl
import evoshift.composeapp.generated.resources.job_lang_uk
import evoshift.composeapp.generated.resources.job_pay_hint
import evoshift.composeapp.generated.resources.job_pay_per_hour
import evoshift.composeapp.generated.resources.job_pay_per_month
import evoshift.composeapp.generated.resources.job_publish
import evoshift.composeapp.generated.resources.job_reopen
import evoshift.composeapp.generated.resources.job_save_draft
import evoshift.composeapp.generated.resources.job_share_copied
import evoshift.composeapp.generated.resources.job_share_copy
import evoshift.composeapp.generated.resources.job_share_draft_hint
import evoshift.composeapp.generated.resources.job_share_hint
import evoshift.composeapp.generated.resources.job_share_open
import evoshift.composeapp.generated.resources.job_share_qr
import evoshift.composeapp.generated.resources.job_share_send
import evoshift.composeapp.generated.resources.job_share_text
import evoshift.composeapp.generated.resources.job_share_title
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.job_section_cv
import evoshift.composeapp.generated.resources.job_cv_required
import evoshift.composeapp.generated.resources.job_cv_optional
import evoshift.composeapp.generated.resources.job_cv_none
import evoshift.composeapp.generated.resources.job_cv_types
import evoshift.composeapp.generated.resources.job_cv_max_size
import evoshift.composeapp.generated.resources.job_cv_hint
import evoshift.composeapp.generated.resources.job_section_recruiters
import evoshift.composeapp.generated.resources.job_recruiters_hint
import evoshift.composeapp.generated.resources.job_recruiters_empty
import evoshift.composeapp.generated.resources.job_section_rejection
import evoshift.composeapp.generated.resources.job_rejection_enabled
import evoshift.composeapp.generated.resources.job_rejection_subject
import evoshift.composeapp.generated.resources.job_rejection_body
import evoshift.composeapp.generated.resources.job_rejection_hint
import io.github.alexzhirkevich.qrose.options.QrErrorCorrectionLevel
import io.github.alexzhirkevich.qrose.options.QrOptions
import io.github.alexzhirkevich.qrose.rememberQrCodePainter
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/** Test tags of the editor. */
object JobPostEditorTags {
    const val LINK = "job_post_link"
    const val QR = "job_post_qr"
    const val DELETE = "job_post_delete"
}

fun JobContractType.label(): StringResource = when (this) {
    JobContractType.EMPLOYMENT -> Res.string.job_contract_employment
    JobContractType.MANDATE -> Res.string.job_contract_mandate
    JobContractType.B2B -> Res.string.job_contract_b2b
    JobContractType.OTHER -> Res.string.job_contract_other
}

/**
 * SH-125: a job post's editor. The fields (title, role, contract, the pay range the law requires,
 * hours, place, last day, description, the employer and data contact the public page's privacy
 * notice names, the page's language) in one card; save as a draft, publish, close or open again;
 * once saved, its public link with copy, the system share sheet ([share]; false: none, so the link
 * is copied), opening the page and a QR code to print; deleting the post with its applicants.
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
fun JobPostEditorScreen(
    viewModel: JobPostEditorViewModel,
    onNavigateBack: () -> Unit,
    share: (text: String, subject: String) -> Boolean
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val messageText = state.message?.asString()
    LaunchedEffect(messageText) {
        messageText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.messageShown()
        }
    }
    LaunchedEffect(state.deleted) { if (state.deleted) onNavigateBack() }
    var confirmDelete by rememberSaveable { mutableStateOf(false) }
    val form = state.form
    val editable = state.canEdit && !state.isLoading
    val problem = state.problem
    fun errorFor(vararg problems: Problem): StringResource? = problem?.takeIf { it in problems }?.let(::jobPostProblemText)

    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                title = stringResource(if (state.post == null) Res.string.job_editor_new_title else Res.string.job_editor_title),
                onBack = onNavigateBack
            )
        }
    ) { padding ->
        Box(Modifier.fillMaxSize().contentWidth(LocalWindowWidthClass.current.wideContentMaxWidth).padding(padding)) {
            Column(
                Modifier.fillMaxSize().verticalScroll(rememberScrollState()).padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                state.post?.let { post -> ShareCard(post, share) }

                StandoutCard(Modifier.fillMaxWidth()) {
                    Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        EvoTextField(
                            value = form.title, onValueChange = { v -> viewModel.edit { it.copy(title = v.take(JobPost.MAX_TITLE)) } },
                            label = stringResource(Res.string.job_field_title),
                            supportingText = stringResource(Res.string.job_field_title_hint),
                            error = errorFor(Problem.TITLE_REQUIRED)?.let { stringResource(it) }, enabled = editable
                        )
                        if (state.roles.isNotEmpty()) {
                            EvoDropdown(
                                label = stringResource(Res.string.job_field_role), options = state.roles,
                                selected = form.role.takeIf { it.isNotBlank() }, onSelected = { r -> viewModel.edit { it.copy(role = r) } },
                                optionLabel = { it }, enabled = editable
                            )
                        } else {
                            EvoTextField(
                                value = form.role, onValueChange = { v -> viewModel.edit { it.copy(role = v.take(JobPost.MAX_ROLE)) } },
                                label = stringResource(Res.string.job_field_role), enabled = editable
                            )
                        }
                        EvoDropdown(
                            label = stringResource(Res.string.job_field_contract), options = JobContractType.entries,
                            selected = form.contractType, onSelected = { c -> viewModel.edit { it.copy(contractType = c) } },
                            optionLabel = { stringResource(it.label()) }, enabled = editable
                        )
                        val payError = errorFor(Problem.PAY_REQUIRED, Problem.PAY_RANGE)?.let { stringResource(it) }
                        EvoTextField(
                            value = form.payMin, onValueChange = { v -> viewModel.edit { it.copy(payMin = v.filter { c -> c.isDigit() || c == ',' || c == '.' }.take(10)) } },
                            label = stringResource(Res.string.job_field_pay_min), suffix = state.currency,
                            keyboardType = KeyboardType.Decimal, error = payError, enabled = editable
                        )
                        EvoTextField(
                            value = form.payMax, onValueChange = { v -> viewModel.edit { it.copy(payMax = v.filter { c -> c.isDigit() || c == ',' || c == '.' }.take(10)) } },
                            label = stringResource(Res.string.job_field_pay_max), suffix = state.currency,
                            keyboardType = KeyboardType.Decimal, supportingText = stringResource(Res.string.job_pay_hint),
                            error = payError, enabled = editable
                        )
                        Choices(
                            options = PayUnit.entries, selected = form.payUnit, enabled = editable,
                            label = { stringResource(if (it == PayUnit.MONTH) Res.string.job_pay_per_month else Res.string.job_pay_per_hour) },
                            onSelect = { u -> viewModel.edit { it.copy(payUnit = u) } }
                        )
                        EvoTextField(
                            value = form.hoursText, onValueChange = { v -> viewModel.edit { it.copy(hoursText = v.take(JobPost.MAX_HOURS)) } },
                            label = stringResource(Res.string.job_field_hours), supportingText = stringResource(Res.string.job_field_hours_hint),
                            enabled = editable
                        )
                        EvoTextField(
                            value = form.city, onValueChange = { v -> viewModel.edit { it.copy(city = v.take(JobPost.MAX_CITY)) } },
                            label = stringResource(Res.string.job_field_city), enabled = editable
                        )
                        EvoDateField(
                            value = form.closesOn, onValueChange = { v -> viewModel.edit { it.copy(closesOn = v) } },
                            label = stringResource(Res.string.job_field_closes),
                            missingYear = MissingYear.Upcoming,
                            error = errorFor(Problem.DATE_INVALID)?.let { stringResource(it) }
                        )
                        EvoTextField(
                            value = form.description, onValueChange = { v -> viewModel.edit { it.copy(description = v.take(JobPost.MAX_DESCRIPTION)) } },
                            label = stringResource(Res.string.job_field_description), singleLine = false, minLines = 4, enabled = editable
                        )
                        EvoTextField(
                            value = form.employerName, onValueChange = { v -> viewModel.edit { it.copy(employerName = v.take(JobPost.MAX_EMPLOYER)) } },
                            label = stringResource(Res.string.job_field_employer), supportingText = stringResource(Res.string.job_field_employer_hint),
                            error = errorFor(Problem.EMPLOYER_REQUIRED)?.let { stringResource(it) }, enabled = editable
                        )
                        EvoTextField(
                            value = form.privacyContact, onValueChange = { v -> viewModel.edit { it.copy(privacyContact = v.take(JobPost.MAX_CONTACT)) } },
                            label = stringResource(Res.string.job_field_contact), supportingText = stringResource(Res.string.job_field_contact_hint),
                            error = errorFor(Problem.CONTACT_REQUIRED, Problem.TOO_LONG)?.let { stringResource(it) },
                            keyboardType = KeyboardType.Email, enabled = editable
                        )
                        Text(stringResource(Res.string.job_field_language), color = Color.White.copy(alpha = 0.8f), style = MaterialTheme.typography.labelLarge)
                        Choices(
                            options = listOf("pl", "en", "uk"), selected = form.lang, enabled = editable,
                            label = {
                                stringResource(
                                    when (it) {
                                        "en" -> Res.string.job_lang_en
                                        "uk" -> Res.string.job_lang_uk
                                        else -> Res.string.job_lang_pl
                                    }
                                )
                            },
                            onSelect = { l -> viewModel.edit { it.copy(lang = l) } },
                            onNavy = true
                        )
                        PostSettings(
                            form = form, team = state.team, editable = editable,
                            cvTypesError = errorFor(Problem.CV_TYPES_REQUIRED)?.let { stringResource(it) },
                            onEdit = viewModel::edit, onToggleType = viewModel::toggleCvType,
                            onToggleRecruiter = viewModel::toggleRecruiter
                        )
                        if (state.canEdit) {
                            val status = state.post?.status
                            FlowRow(horizontalArrangement = Arrangement.spacedBy(12.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                                when (status) {
                                    JobPostStatus.OPEN -> {
                                        EvoPrimaryButton(DialogAction(stringResource(Res.string.save), { viewModel.save(JobPostStatus.OPEN) }, loading = state.isSaving))
                                        EvoSecondaryButton(DialogAction(stringResource(Res.string.job_close), { viewModel.save(JobPostStatus.CLOSED) }, enabled = !state.isSaving))
                                    }
                                    JobPostStatus.CLOSED -> {
                                        EvoPrimaryButton(DialogAction(stringResource(Res.string.job_reopen), { viewModel.save(JobPostStatus.OPEN) }, loading = state.isSaving))
                                        EvoSecondaryButton(DialogAction(stringResource(Res.string.save), { viewModel.save(JobPostStatus.CLOSED) }, enabled = !state.isSaving))
                                    }
                                    else -> {
                                        EvoPrimaryButton(DialogAction(stringResource(Res.string.job_publish), { viewModel.save(JobPostStatus.OPEN) }, loading = state.isSaving))
                                        EvoSecondaryButton(DialogAction(stringResource(Res.string.job_save_draft), { viewModel.save(JobPostStatus.DRAFT) }, enabled = !state.isSaving))
                                    }
                                }
                            }
                        }
                        if (state.post != null && state.capabilities.shows(Gate.HIRING)) {
                            EvoSecondaryButton(
                                DialogAction(stringResource(Res.string.job_delete), { confirmDelete = true }, destructive = true, icon = Icons.Default.Delete),
                                quiet = true,
                                modifier = Modifier.testTag(JobPostEditorTags.DELETE)
                            )
                        }
                    }
                }
            }
            LoadingOverlay(isLoading = state.isLoading)
        }
    }

    if (confirmDelete) {
        EvoConfirmDialog(
            title = stringResource(Res.string.job_delete_confirm_title),
            text = stringResource(Res.string.job_delete_confirm_text),
            confirmLabel = stringResource(Res.string.job_delete),
            onConfirm = {
                confirmDelete = false
                viewModel.delete()
            },
            onDismiss = { confirmDelete = false },
            destructive = true,
            icon = Icons.Default.Delete
        )
    }
}

/** SH-210: the tags of the post's settings. */
object JobPostSettingsTags {
    const val CV_SECTION = "job_post_cv"
    const val RECRUITERS = "job_post_recruiters"
    const val REJECTION = "job_post_rejection"
    fun cvType(type: CvFileType) = "job_post_cv_type_${type.id}"
    fun cvSize(mb: Int) = "job_post_cv_size_$mb"
    fun recruiter(uid: String) = "job_post_recruiter_$uid"
}

/** The label of a CV setting. */
fun CvRequirement.label(): StringResource = when (this) {
    CvRequirement.REQUIRED -> Res.string.job_cv_required
    CvRequirement.OPTIONAL -> Res.string.job_cv_optional
    CvRequirement.NONE -> Res.string.job_cv_none
}

/**
 * SH-210: the post's own settings: the CV (required, optional or none; the file kinds; the largest
 * size, 1 to 5 MB), the recruiters chosen from the team, and the rejection e-mail's template.
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun PostSettings(
    form: com.evoapps.evoshift.viewmodels.JobPostForm,
    team: List<User>,
    editable: Boolean,
    cvTypesError: String?,
    onEdit: ((com.evoapps.evoshift.viewmodels.JobPostForm) -> com.evoapps.evoshift.viewmodels.JobPostForm) -> Unit,
    onToggleType: (CvFileType) -> Unit,
    onToggleRecruiter: (String) -> Unit
) {
    val colors = FilterChipDefaults.filterChipColors(
        selectedContainerColor = MaterialTheme.colorScheme.secondary, selectedLabelColor = DeepNavy, labelColor = Color.White
    )
    @Composable
    fun Heading(text: String) = Text(text, color = Color.White, style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold)
    @Composable
    fun Hint(text: String) = Text(text, color = Color.White.copy(alpha = 0.8f), style = MaterialTheme.typography.bodySmall)

    Column(Modifier.fillMaxWidth().testTag(JobPostSettingsTags.CV_SECTION), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Heading(stringResource(Res.string.job_section_cv))
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            CvRequirement.entries.forEach { option ->
                FilterChip(
                    selected = form.cv.requirement == option, enabled = editable, colors = colors, modifier = Modifier.handCursor(),
                    onClick = { onEdit { it.copy(cv = it.cv.copy(requirement = option)) } },
                    label = { Text(stringResource(option.label())) }
                )
            }
        }
        if (form.cv.requirement != CvRequirement.NONE) {
            Hint(stringResource(Res.string.job_cv_types))
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                CvFileType.entries.forEach { type ->
                    FilterChip(
                        selected = type in form.cv.types, enabled = editable, colors = colors,
                        modifier = Modifier.handCursor().testTag(JobPostSettingsTags.cvType(type)),
                        onClick = { onToggleType(type) },
                        label = { Text(type.id.uppercase()) }
                    )
                }
            }
            cvTypesError?.let { Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall) }
            Hint(stringResource(Res.string.job_cv_max_size, form.cv.maxMb))
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                (CvSettings.MIN_MB..CvSettings.MAX_MB).forEach { mb ->
                    FilterChip(
                        selected = form.cv.maxMb == mb, enabled = editable, colors = colors,
                        modifier = Modifier.handCursor().testTag(JobPostSettingsTags.cvSize(mb)),
                        onClick = { onEdit { it.copy(cv = it.cv.copy(maxMb = mb)) } },
                        label = { Text("$mb MB") }
                    )
                }
            }
            Hint(stringResource(Res.string.job_cv_hint))
        }
    }
    Column(Modifier.fillMaxWidth().testTag(JobPostSettingsTags.RECRUITERS), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Heading(stringResource(Res.string.job_section_recruiters))
        Hint(stringResource(Res.string.job_recruiters_hint))
        if (team.isEmpty()) Hint(stringResource(Res.string.job_recruiters_empty))
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            team.forEach { person ->
                FilterChip(
                    selected = person.uid in form.recruiterIds, enabled = editable, colors = colors,
                    modifier = Modifier.handCursor().testTag(JobPostSettingsTags.recruiter(person.uid)),
                    onClick = { onToggleRecruiter(person.uid) },
                    label = { Text(person.displayName) }
                )
            }
        }
    }
    Column(Modifier.fillMaxWidth().testTag(JobPostSettingsTags.REJECTION), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Heading(stringResource(Res.string.job_section_rejection))
        EvoSwitchRow(
            checked = form.rejectionMail.enabled, enabled = editable,
            onCheckedChange = { on -> onEdit { it.copy(rejectionMail = it.rejectionMail.copy(enabled = on)) } },
            label = stringResource(Res.string.job_rejection_enabled)
        )
        EvoTextField(
            value = form.rejectionMail.subject, enabled = editable,
            onValueChange = { v -> onEdit { it.copy(rejectionMail = it.rejectionMail.copy(subject = v.take(RejectionMailTemplate.MAX_SUBJECT))) } },
            label = stringResource(Res.string.job_rejection_subject)
        )
        EvoTextField(
            value = form.rejectionMail.body, enabled = editable, singleLine = false, minLines = 4,
            onValueChange = { v -> onEdit { it.copy(rejectionMail = it.rejectionMail.copy(body = v.take(RejectionMailTemplate.MAX_BODY))) } },
            label = stringResource(Res.string.job_rejection_body),
            supportingText = stringResource(Res.string.job_rejection_hint)
        )
    }
}

/** Chips for one of [options]. */
@Composable
private fun <T> Choices(
    options: List<T>,
    selected: T,
    enabled: Boolean,
    label: @Composable (T) -> String,
    onSelect: (T) -> Unit,
    onNavy: Boolean = true
) {
    val colors = FilterChipDefaults.filterChipColors(
        selectedContainerColor = MaterialTheme.colorScheme.secondary,
        selectedLabelColor = DeepNavy,
        labelColor = if (onNavy) Color.White else DeepNavy
    )
    androidx.compose.foundation.layout.Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        options.forEach { option ->
            FilterChip(
                selected = option == selected,
                onClick = { onSelect(option) },
                enabled = enabled,
                label = { Text(label(option)) },
                colors = colors,
                modifier = Modifier.handCursor()
            )
        }
    }
}

/** The public link: copy, share, open; the QR code while the post is published. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ShareCard(post: JobPost, share: (String, String) -> Boolean) {
    val clipboard = LocalClipboard.current
    val uriHandler = LocalUriHandler.current
    val scope = rememberCoroutineScope()
    var copied by remember(post.id) { mutableStateOf(false) }
    val url = post.shareUrl
    val shareText = stringResource(Res.string.job_share_text, post.title, url)
    val copy = {
        scope.launch {
            clipboard.setClipEntry(plainTextClipEntry(url))
            copied = true
        }
        Unit
    }
    StandoutCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Text(stringResource(Res.string.job_share_title), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = Color.White)
            Text(
                stringResource(if (post.status == JobPostStatus.OPEN) Res.string.job_share_hint else Res.string.job_share_draft_hint),
                style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.75f)
            )
            Text(url, color = Color.White, style = MaterialTheme.typography.bodyMedium, modifier = Modifier.testTag(JobPostEditorTags.LINK))
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                EvoSecondaryButton(
                    DialogAction(stringResource(if (copied) Res.string.job_share_copied else Res.string.job_share_copy), copy, icon = Icons.Default.ContentCopy),
                    quiet = true
                )
                EvoSecondaryButton(
                    DialogAction(stringResource(Res.string.job_share_send), { if (!share(shareText, post.title)) copy() }, icon = Icons.Default.Share),
                    quiet = true
                )
                EvoSecondaryButton(
                    DialogAction(stringResource(Res.string.job_share_open), { uriHandler.openUri(url) }, icon = Icons.AutoMirrored.Filled.OpenInNew),
                    quiet = true
                )
            }
            if (post.status == JobPostStatus.OPEN) {
                val description = stringResource(Res.string.job_share_qr)
                val painter = rememberQrCodePainter(url, remember { QrOptions(errorCorrectionLevel = QrErrorCorrectionLevel.Medium) })
                Box(Modifier.clip(RoundedCornerShape(12.dp)).background(Color.White).padding(10.dp)) {
                    Image(painter = painter, contentDescription = description, modifier = Modifier.size(160.dp).testTag(JobPostEditorTags.QR))
                }
            }
        }
    }
}
